import { createContext } from "react";

type UserRole = 'admin' | 'superadmin' | 'moderator';

type AuthContextType = {
    isAuthenticated: boolean;
    userRole: UserRole | null;
    setAuth: (auth: boolean) => void;
    setUserRole: (role: UserRole | null) => void;
};

const AuthContext = createContext<AuthContextType>({
    isAuthenticated: false,
    userRole: null,
    setAuth: () => {},
    setUserRole: () => {}
});

export type { UserRole };
export default AuthContext;